import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateEmail, useMediaQuery } from './shared-functions.js';
import { db } from "./use-firebase.js";
import { collection, addDoc } from 'firebase/firestore'; // collection, addDoc, getDocs, query, where
import { Row, Col, Button, Image, Modal, Form, Card } from 'react-bootstrap';
import Footer from './components/common/Footer.js';
import { ArrowRight } from "phosphor-react";
import Logo from "./components/common/Logo.js";
import { ToastContainer, toast, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Frontpage() {

  const navigate = useNavigate();
  let isPageWide = useMediaQuery('(min-width: 960px)');

  const [waitlistName, setWaitlistName] = useState(null);
  const [waitlistEmail, setWaitlistEmail] = useState(null);
  const [waitlistUrl, setWaitlistUrl] = useState(null);
  const [validated, setValidated] = useState(false);
  const [openWaitlist, setOpenWaitlist] = useState(false);

  const addToWaitlist = (event) => {
    if (event) {
      const form = event.currentTarget;
      event.preventDefault();
      event.stopPropagation();
      if (form.checkValidity() === true) {
        addDoc(collection(db, "waitlists"), { name: waitlistName,
                                              email: waitlistEmail,
                                              socialUrl: waitlistUrl,
                                              createdTs: Date.now(),
                                              visibility: 'hG38waslVcs7U086RhaZut'
        }).then(() => {
          setWaitlistName("");
          setWaitlistEmail("");
          setWaitlistUrl("");
          setOpenWaitlist(false);
          doToast("You'll hear from us soon!")
          setValidated(false);
        })
      }
      setValidated(true);
    }
  };

  const doToast = (text) => {
    toast(text, {
      position: "top-center",
      theme: "dark",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  return (
    <Row style={{ justifyContent: 'center' }}>
      <Col style={{ padding: 0 }}>
        <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, paddingTop: 100, paddingBottom: 100, minHeight: '50vh', backgroundImage: `url('/assets/frontpage/background.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <Col xs={11} sm={10} md={10} lg={5} xl={5} style={{ padding: 20 }}>
            <h1 style={{ color: '#FFFFFF', maxWidth: 500 }}>The sustainability platform for climate-forward businesses</h1>
            {/* <h1 style={{ color: '#FFFFFF', maxWidth: 500 }}>Become a carbon-neutral business</h1> */}
            <Row style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start', marginLeft: 0, marginRight: 0, marginTop: 20, maxWidth: 500 }}>
              <Col xs={12} sm={11} md={11} lg={8} xl={8} style={{ padding: 0 }}>
                <p style={{ marginTop: 0, color: '#EEEEEE' }}>Molecule helps businesses measure, reduce, remove and offset their carbon footprint. Begin your journey towards carbon-neutrality in minutes.</p>
                <Button variant="primary" onClick={() => setOpenWaitlist(true)} style={{ marginTop: 30 }}>Book a demo <ArrowRight weight="bold" size={14} style={{ marginBottom: 3 }} /></Button>
              </Col>
            </Row>
          </Col>
          <Col xs={11} sm={9} md={8} lg={5} xl={5} style={{ padding: 20, textAlign: 'center', maxWidth: 500 }}>
            <Image src={'/assets/frontpage/hero2.png'} style={{ height: 600 }} />
          </Col>
        </Row>
        {/* 71% customers prefer */}        
        <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, paddingTop: 120, backgroundColor: '#EEEEEE' }}>
          <Col xs={11} sm={10} md={8} lg={7} xl={5} style={{ textAlign: 'center' }}>
            <h3 style={{ textAlign: 'center' }}>Turn climate action into your marketing superpower</h3> 
          </Col>
        </Row>
        <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start', marginLeft: 0, marginRight: 0, paddingTop: 40, paddingBottom: 140, backgroundColor: '#EEEEEE' }}>
          <Col xs={6} sm={5} md={5} lg={3} xl={3} style={{ textAlign: 'center', marginBottom: 20 }}>
            <Image src={'/assets/frontpage/71.png'} style={{ maxWidth: 160 }} />
            <p style={{ marginTop: 10 }}>of consumers will pay a premium for sustainable products</p>
          </Col>
          <Col xs={6} sm={5} md={5} lg={3} xl={3} style={{ textAlign: 'center', marginBottom: 20 }}>
            <Image src={'/assets/frontpage/57.png'} style={{ maxWidth: 160 }} />
            <p style={{ marginTop: 10 }}>of shoppers will pass on a product if its packaging harms the environment</p>
          </Col>
          <Col xs={6} sm={5} md={5} lg={3} xl={3} style={{ textAlign: 'center', marginBottom: 20 }}>
            <Image src={'/assets/frontpage/53.png'} style={{ maxWidth: 160 }} />
            <p style={{ marginTop: 10 }}>would use a brand less if it wasn't operating sustainably</p>
          </Col>
        </Row>
        {/* best brands choose */}
        <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, paddingTop: 140, paddingBottom: 140, backgroundColor: '#90ee90' }}>
          <Col xs={11} sm={9} md={8} lg={5} xl={5} style={{ padding: 20, textAlign: 'center', maxWidth: 600 }}>
            <Image src={'/assets/frontpage/carbon-accounting.png'} style={{ width: '100%' }} />
          </Col>
          <Col xs={11} sm={10} md={8} lg={5} xl={5} style={{ padding: 20, maxWidth: 600 }}>
            <h6 className='small bold' style={{ color: '#111111' }}>Carbon accounting</h6>
            <h2 style={{ maxWidth: 500 }}>Good for business, people, and planet</h2>
            <Row style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start', marginLeft: 0, marginRight: 0, marginTop: 20, maxWidth: 500 }}>
              <Col xs={12} sm={11} md={11} lg={10} xl={10} style={{ padding: 0 }}>
                <p style={{ marginTop: 0 }}>There's a reason why thousands of the world's most loved brands are investing resources in carbon emissions accounting - it's not only a great opportunity to reduce greenhouse gas emissions, but greener choices in materials, logistics and manufacturing now helps businesses drive down costs and increase profits.</p>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* how it works - measure, set targets, reduce, remove */}
        <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, paddingTop: 80 }}>
          <Col xs={11} sm={10} md={8} lg={7} xl={5} style={{ textAlign: 'center' }}>
            <h6 className='small bold' style={{ color: '#77E3F3' }}>How it works</h6>
            <h3 style={{ textAlign: 'center', color: '#FFFFFF' }}>Complete climate action, from measurements to removal</h3> 
          </Col>
        </Row>
        <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start', marginLeft: 0, marginRight: 0, paddingTop: 40 }}>
          <Col xs={5} sm={5} md={4} lg={5} xl={5} style={{ padding: 20, textAlign: 'left', maxWidth: 400 }}>
            <h4 style={{ color: '#FFFFFF' }}>1. Measure</h4>
            <p className='muted' style={{ marginTop: 0, color: '#FFFFFF' }}>Use Molecule's extensive data collection and visualization tools to measure your Scope 1, 2 and 3 emissions from cradle to grave.</p>
          </Col>
          <Col xs={5} sm={5} md={4} lg={5} xl={5} style={{ padding: 20, textAlign: 'left', maxWidth: 400 }}>
            <h4 style={{ color: '#FFFFFF' }}>2. Reduce</h4>
            <p className='muted' style={{ marginTop: 0, color: '#FFFFFF' }}>Set carbon reduction targets for the company, identify areas of greatest improvement, and plan actions that help reduce your emissions.</p>
          </Col>
        </Row>
        <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start', marginLeft: 0, marginRight: 0, paddingTop: 40, paddingBottom: 100 }}>
          <Col xs={5} sm={5} md={4} lg={5} xl={5} style={{ padding: 20, textAlign: 'left', maxWidth: 400 }}>
            <h4 style={{ color: '#FFFFFF' }}>3. Remove</h4>
            <p className='muted' style={{ marginTop: 0, color: '#FFFFFF' }}>Find opportunities with materials, manufacturing, supply chain, logistics, packaging or your product's end-of-life you can remove emissions altogether.</p>
          </Col>
          <Col xs={5} sm={5} md={4} lg={5} xl={5} style={{ padding: 20, textAlign: 'left', maxWidth: 400 }}>
            <h4 style={{ color: '#FFFFFF' }}>4. Offset</h4>
            <p className='muted' style={{ marginTop: 0, color: '#FFFFFF' }}>For the remainder of carbon emissions, buy credits from global carbon projects verified and updated by Molecule's offsetting partners.</p>
          </Col>
        </Row>
        {/* <Col xs={11} sm={9} md={8} lg={6} xl={6} style={{ padding: 20, textAlign: 'center', maxWidth: 600 }}>
            <Image src={'/assets/frontpage/clothing.jpg'} style={{ width: '90%' }} />
          </Col> */}
        {/* Molecule - Data from good sources, quick and easy */}
        <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, paddingTop: 120, backgroundColor: '#FCF2D8' }}>
          <Col xs={12} sm={11} md={8} lg={6} xl={5} style={{ textAlign: 'center' }}>
            <h6 className='small bold' style={{ color: '#585A2D' }}>Carbon Offsetting</h6>
            <h3 style={{ textAlign: 'center' }}>Verified credits from global projects</h3>
            <p style={{ marginTop: 0 }}>Buy directly from one of Molecule's partners responisble for verification and vetting of carbon reduction and removal projects from around the world.</p>
          </Col>
        </Row>
        <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, paddingTop: 40, paddingBottom: 160, paddingLeft: 40, paddingRight: 40, backgroundColor: '#FCF2D8' }}>
          <Col xs={6} sm={6} md={4} lg={4} xl={3} style={{ textAlign: 'left', marginBottom: 20 }}>
            <Card>
              <Card.Img variant="top" src="/assets/frontpage/projects/farmland-regeneration.jpeg" style={{ height: 200, objectFit: 'cover' }} />
              <Card.Body style={{ padding: 0, marginTop: 10 }}>
                <Card.Title><p className='bold'>Farmland regeneration</p></Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={6} sm={6} md={4} lg={4} xl={3} style={{ textAlign: 'left', marginBottom: 20 }}>
            <Card>
              <Card.Img variant="top" src="/assets/frontpage/projects/biochar.jpeg" style={{ height: 200, objectFit: 'cover' }} />
              <Card.Body style={{ padding: 0, marginTop: 10 }}>
                <Card.Title><p className='bold'>Biochar</p></Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={6} sm={6} md={4} lg={4} xl={3} style={{ textAlign: 'left', marginBottom: 20 }}>
            <Card>
              <Card.Img variant="top" src="/assets/frontpage/projects/direct-air-capture.jpeg" style={{ height: 200, objectFit: 'cover' }} />
              <Card.Body style={{ padding: 0, marginTop: 10 }}>
                <Card.Title><p className='bold'>Direct Air Capture</p></Card.Title>
              </Card.Body>
            </Card>
          </Col>
          {/* <Col xs={6} sm={6} md={4} lg={4} xl={3} style={{ textAlign: 'left', marginBottom: 20 }}>
            <Card>
              <Card.Img variant="top" src="/assets/frontpage/projects/wind-farm.jpeg" style={{ height: 200, objectFit: 'cover' }} />
              <Card.Body style={{ padding: 0, marginTop: 10 }}>
                <Card.Title><p className='bold'>Wind Energy</p></Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={6} sm={6} md={4} lg={4} xl={3} style={{ textAlign: 'left', marginBottom: 20 }}>
            <Card>
              <Card.Img variant="top" src="/assets/frontpage/projects/hydroelectric.jpeg" style={{ height: 200, objectFit: 'cover' }} />
              <Card.Body style={{ padding: 0, marginTop: 10 }}>
                <Card.Title><p className='bold'>Hydroelectric Energy</p></Card.Title>
              </Card.Body>
            </Card>
          </Col> */}
        </Row>
        {/* carbon removal marketplace */}
        {/* Logos - GHG protocol */}
        <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, paddingTop: 80, paddingBottom: 120, minHeight: '40vh' }}>
          <Col xs={11} sm={10} md={8} lg={7} xl={5} style={{ textAlign: 'center' }}>
            <h3 style={{ textAlign: 'center', color: '#FFFFFF' }}>Begin your carbon journey</h3>
            <Button variant="primary" onClick={() => setOpenWaitlist(true)} style={{ marginTop: 20 }}>Book a demo <ArrowRight weight="bold" size={14} style={{ marginBottom: 3 }} /></Button>
          </Col>
        </Row>
      </Col>
      <Modal
        show={openWaitlist}
        centered
        size="md"
        fullscreen='xs-down'
        style={{ backgroundColor: '#100E15AA' }}
        onHide={() => setOpenWaitlist(false)}>
        <Modal.Body style={{ backgroundColor: '#100E15', color: '#EEEEEE', padding: 40, boxShadow: '0 5px 15px rgba(0,0,0,.5)' }}>
          <h4>Book a demo</h4>
          {/* <p className="small" style={{ marginTop: 10 }}>We'll get back to you with .</p> */}
          <Form noValidate validated={validated} onSubmit={addToWaitlist} style={{ marginTop: 20 }}>
            <Form.Label style={{ marginBottom: 0 }}>Name</Form.Label>
            <Form.Group controlId="name">
              <Form.Control required as="input" type="text" minLength="3" maxLength="180" value={waitlistName} onChange={(e) => setWaitlistName(e.target.value)} />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">Enter a valid name</Form.Control.Feedback>
            </Form.Group>
            <Form.Label style={{ marginTop: 20, marginBottom: 0 }}>Email</Form.Label>
            <Form.Group controlId="email">
              <Form.Control required as="input" type="email" minLength="3" maxLength="180" value={waitlistEmail} onChange={(e) => setWaitlistEmail(e.target.value)} />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">Enter a valid email address</Form.Control.Feedback>
            </Form.Group>
            <Form.Label style={{ marginTop: 20, marginBottom: 0 }}>Website URL</Form.Label>
            <Form.Group controlId="website">
              <Form.Control required as="input" type="url" minLength="3" maxLength="180" value={waitlistUrl} onChange={(e) => setWaitlistUrl(e.target.value)} />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">Enter a valid URL</Form.Control.Feedback>
            </Form.Group>
            <Button type="submit" style={{ marginTop: 30 }}>Submit</Button>
            <p className="small muted" style={{ marginTop: 10 }}>We deeply care about data privacy. Your email will only be used to help schedule a demo.</p>
          </Form>
        </Modal.Body>
      </Modal>

      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Footer />
    </Row>
  );

}

// return (
//   <Row style={{ justifyContent: 'center' }}>

//     <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, marginTop: 60, minHeight: '80vh' }}>
//       <Col xs={11} sm={9} md={8} lg={8} xl={8} style={{ padding: 20, textAlign: 'center', maxWidth: 840 }}>
//         <h2 className="glow" style={{ }}>Earn rewards for climate action</h2>
//         <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'left', marginLeft: 0, marginRight: 0, marginTop: 20 }}>
//           <Col xs={12} sm={11} md={11} lg={10} xl={9} style={{ padding: 0 }}>
//             <p style={{ marginTop: 0 }}>You read that right! Climate action pays. From discounts on your favorite sustainable products and services, to dividends on climate investments, use Molecule to earn rewards for your actions.</p>
//             <Button onClick={() => setOpenWaitlist(true)} style={{ marginTop: 40 }}>Request access</Button>
//             <Image src={'/assets/frontpage/projects-products.png'} style={{ width: '100%', marginTop: 40 }} />
//           </Col>
//         </Row>
//       </Col>
//       <Footer />
//     </Row>
//   </Row>
// );

// return (
//   <Row style={{ justifyContent: 'center' }}>

//     <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, marginTop: 60, minHeight: '80vh' }}>
//       <Col xs={11} sm={9} md={8} lg={8} xl={8} style={{ padding: 20, textAlign: 'center', maxWidth: 840 }}>
//         <h1 className="glow" style={{ }}>Earn rewards for a healthy, sustainable lifestyle</h1>
//         <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'left', marginLeft: 0, marginRight: 0, marginTop: 20 }}>
//           <Col xs={12} sm={11} md={11} lg={10} xl={9} style={{ padding: 0 }}>
//             <p style={{ marginTop: 0 }}>Up to 20% in cashback plus dividends</p>
//             <Button onClick={() => setOpenWaitlist(true)} style={{ marginTop: 40 }}>Join waitlist</Button>
//             <Image src={'/assets/frontpage/projects-products.png'} style={{ width: '100%', marginTop: 40 }} />
//           </Col>
//         </Row>

//       </Col>
//     </Row>

//     <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, minHeight: '80vh' }}>
//       <Col xs={11} sm={9} md={5} lg={5} xl={4} style={{ padding: 20, maxWidth: 480 }}>
//         <h6 style={{  }}>Earn</h6>
//         <h1 style={{ marginTop: 10 }}>Earn points for healthy actions</h1>
//         <Row style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'left', marginLeft: 0, marginRight: 0, marginTop: 20 }}>
//           <Col xs={12} sm={11} md={11} lg={10} xl={9} style={{ padding: 0 }}>
//             <p style={{ marginTop: 0 }}>Walk, meditate, be mindful, schedule an annual physical - earn points for all the actions you take to keep yourself healthy.</p>
//           </Col>
//         </Row>
//       </Col>
//       <Col xs={11} sm={9} md={6} lg={6} xl={5} style={{ padding: 40, textAlign: 'center', maxWidth: 640 }}>
//         <Image src={'/assets/frontpage/earn-tokens.png'} style={{ width: '100%' }} />
//       </Col>
//     </Row>

//     <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, minHeight: '80vh' }}>
//       <Col xs={11} sm={9} md={5} lg={5} xl={4} style={{ padding: 20, maxWidth: 480 }}>
//         <h6 style={{  }}>Cashback</h6>
//         <h1 style={{ marginTop: 10 }}>Earn points for shopping healthy</h1>
//         <Row style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'left', marginLeft: 0, marginRight: 0, marginTop: 20 }}>
//           <Col xs={12} sm={11} md={11} lg={10} xl={9} style={{ padding: 0 }}>
//             <p style={{ marginTop: 0 }}>Shop products from your favorite brands and earn up to 20% cashback rewards in the form of points</p>
//           </Col>
//         </Row>
//       </Col>
//       <Col xs={11} sm={9} md={6} lg={6} xl={5} style={{ padding: 40, textAlign: 'center', maxWidth: 640 }}>
//         <Image src={'/assets/frontpage/shop-brands.png'} style={{ width: '100%' }} />
//       </Col>
//     </Row>

//     <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, minHeight: '80vh' }}>
//       <Col xs={11} sm={9} md={5} lg={5} xl={4} style={{ padding: 20, maxWidth: 480 }}>
//         <h6 style={{  }}>Invest</h6>
//         <h1 style={{ marginTop: 10 }}>Earn dividends for investing</h1>
//         <Row style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'left', marginLeft: 0, marginRight: 0, marginTop: 20 }}>
//           <Col xs={12} sm={11} md={11} lg={10} xl={9} style={{ padding: 0 }}>
//             <p style={{ marginTop: 0 }}>Invest your points in carbon removal projects, renewable energy projects and ESG funds to not only do your bit, but also earn dividends</p>
//           </Col>
//         </Row>
//       </Col>
//       <Col xs={11} sm={9} md={6} lg={6} xl={5} style={{ padding: 40, textAlign: 'center', maxWidth: 640 }}>
//         <Image src={'/assets/frontpage/earn-dividends.png'} style={{ width: '100%' }} />
//       </Col>
//     </Row>

//     <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, minHeight: '80vh' }}>
//       <Col xs={11} sm={9} md={5} lg={5} xl={4} style={{ padding: 20, maxWidth: 480 }}>
//         <h6>Cashout</h6>
//         <h1 style={{ marginTop: 10 }}>Swap points for crypto or discounts</h1>
//         <Row style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'left', marginLeft: 0, marginRight: 0, marginTop: 20 }}>
//           <Col xs={12} sm={11} md={11} lg={10} xl={9} style={{ padding: 0 }}>
//             <p style={{ marginTop: 0 }}>Reward yourself with discounts coupons, gift cards or cryptocurrencies when you wish to cash out your points</p>
//           </Col>
//         </Row>
//       </Col>
//       <Col xs={11} sm={9} md={6} lg={6} xl={5} style={{ padding: 40, textAlign: 'center', maxWidth: 640 }}>
//         <Image src={'/assets/frontpage/rewards-discounts.png'} style={{ width: '100%', marginTop: 20, marginBottom: 20 }} />
//       </Col>
//     </Row>

//     <Row className="sectiongradientred" style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, minHeight: '40vh' }}>
//       <Col xs={11} sm={9} md={7} lg={6} xl={7} style={{ padding: 60, textAlign: 'center', marginTop: 120, marginBottom: 120 }}>
//         <h6>Make it count</h6>
//         <h1 style={{ marginTop: 10 }}>Join the community</h1>
//         <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginLeft: 0, marginRight: 0, marginTop: 30 }}>
//           <Button onClick={() => setOpenWaitlist(true)}>Join waitlist</Button>
//         </Row>
//       </Col>
//     </Row>

//     <Modal
//       show={openWaitlist}
//       centered
//       size="md"
//       fullscreen='xs-down'
//       style={{ backgroundColor: '#050A3099' }}
//       onHide={() => setOpenWaitlist(false)}>
//       <Modal.Body style={{ backgroundColor: '#050A30', color: '#EEEEEE', padding: 40, boxShadow: '0 5px 15px rgba(0,0,0,.5)' }}>
//         <h3>Join waitlist</h3>
//         <p style={{ marginTop: 10 }}>We'll email you when as soon as we are ready to add more beta users.</p>
//         <Form noValidate validated={validated} onSubmit={addToWaitlist} style={{ marginTop: 20 }}>
//           <Form.Label style={{ marginBottom: 0 }}><h6>Name</h6></Form.Label>
//           <Form.Group controlId="name">
//             <Form.Control required as="input" type="text" minLength="3" maxLength="180" value={waitlistName} onChange={(e) => setWaitlistName(e.target.value)} />
//             <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
//             <Form.Control.Feedback type="invalid">Enter a valid name</Form.Control.Feedback>
//           </Form.Group>
//           <Form.Label style={{ marginTop: 20, marginBottom: 0 }}><h6>Email</h6></Form.Label>
//           <Form.Group controlId="email">
//             <Form.Control required as="input" type="email" minLength="3" maxLength="180" value={waitlistEmail} onChange={(e) => setWaitlistEmail(e.target.value)} />
//             <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
//             <Form.Control.Feedback type="invalid">Enter a valid email address</Form.Control.Feedback>
//           </Form.Group>
//           <Button type="submit" style={{ marginTop: 30 }}>Submit</Button>
//           <Form.Label style={{ marginTop: 20 }}><p className="small muted">We deeply care about data privacy. Your email will only be used only to let you know about this waitlist.</p></Form.Label>
//         </Form>
//       </Modal.Body>
//     </Modal>

//     <ToastContainer
//       position="top-center"
//       autoClose={2000}
//       hideProgressBar={false}
//       newestOnTop={false}
//       closeOnClick
//       rtl={false}
//       pauseOnFocusLoss
//       draggable
//       pauseOnHover
//     />

//     <Footer />

//   </Row>
// )